import { z } from 'zod';

/**
 * A person id and a contact id in the forms person rules match (wayai-pro/wayai#5473 §1). Apart from
 * `person-links.ts`, which re-exports them, so a contract that only checks an id's form (an eval's declared
 * persons, `evals.ts`) loads neither the person-link routes' contract nor the contact book's.
 */

/**
 * A user's person id in an org: `prs_` and the 52 base32 characters of an HMAC. The server derives
 * it (`utils/person-id.ts`, whose own pattern its test pins to this one).
 */
export const PERSON_ID_PATTERN = /^prs_[a-z2-7]{52}$/;

/** A contact id as the book writes it, which a person field holds literally: a lowercase UUID. */
export const CONTACT_PERSON_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

/** What a request naming a person id or contact id in the wrong form is told. */
export const PERSON_ID_FORM_MESSAGE = 'Must be a person id (prs_…) or a contact id (a lowercase UUID)';

/** A user's person id. */
export const userPersonIdSchema = z.string().regex(PERSON_ID_PATTERN, { message: 'Must be a person id (prs_…)' });

/** What a person link points at, and what the deny list holds: a user's person id, or a contact id of the book. */
export const personIdSchema = z.string().refine(
  (value) => PERSON_ID_PATTERN.test(value) || CONTACT_PERSON_ID_PATTERN.test(value),
  { message: PERSON_ID_FORM_MESSAGE },
);
